import React from 'react';
import useServerStatus from '../../hooks/useServerStatus';
import MaintenancePage from '../MaintenancePage/MaintenancePage';
import ServerDownPage from '../ServerDownPage/ServerDownPage';

const ServerStatusGuard = ({ children }) => {
  const {
    isMaintenance,
    isServerDown,
    serverDownMessage,
    maintenanceMessage,
    maintenanceSubText,
    maintenanceStartTime,
    maintenanceEndTime,
  } = useServerStatus();

  if (isMaintenance) {
    return (
      <MaintenancePage
        message={maintenanceMessage}
        subText={maintenanceSubText}
        startTime={maintenanceStartTime}
        endTime={maintenanceEndTime}
      />
    );
  }

  if (isServerDown) {
    return <ServerDownPage subText={serverDownMessage} />;
  }

  return <>{children}</>;
};

export default ServerStatusGuard;
